export const DEFAULT_START_TIME = 480;
export const SUGGESTED_TIME_DIMENSIONS = [20, 30, 35, 40, 45];
export const TIME_MAX_LENGTH = 9;
export const TIME_MAX_VALUE = 999999999;
export const TIME_MAX_HOURS = 23;
export const TIME_MAX_MINUTES = 59;
export const TIME_DO_NOT_CHANGE = -1;
export const MIN_WORKING_HOURS = 6;
export const MAX_WORKING_HOURS = 18;
